import * as React from "react";

import { titles } from "../../../constants/titles";
import {
  API_URL,
  Context,
  contractManagementPath,
  fetchSchoolDocuments,
  clearErrorMessage,
} from "../../../managerStore";
import { TManagerSchoolDocumentCategory } from "../../../state";
import { Breadcrumb } from "../../../molecules/Breadcrumb";
import SchoolDocumentList from "../../../templates/manager/SchoolDocumentList";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import useTokenizedDownload from "../../../hooks/manager/useTokenizedDownload";

const DEFAULT_CATEGORY: TManagerSchoolDocumentCategory = "delivery_and_invoice";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const [calling, peep] = useWaitApiCall(state);
  const [category, setCategory] =
    React.useState<TManagerSchoolDocumentCategory>(DEFAULT_CATEGORY);
  const requestDownload = useTokenizedDownload();

  React.useEffect(() => {
    dispatch(peep(fetchSchoolDocuments(category)));
    return () => dispatch(clearErrorMessage());
  }, [dispatch, peep, category]);

  const downloadPdfFunc = React.useCallback(
    (documentId: number) => {
      requestDownload({
        buildUrl: temporaryToken =>
          `${API_URL}/school_documents/${documentId}/pdf?temporary_token=${temporaryToken}`,
        content: <span>PDFを開きます。よろしいですか？</span>,
      });
    },
    [requestDownload],
  );

  return (
    <div>
      <Breadcrumb
        links={[
          { title: titles.contractManagement, to: contractManagementPath },
        ]}
        currentTitle={titles.schoolDocuments}
      />
      <SchoolDocumentList
        documents={state.school_documents_list}
        category={category}
        calling={calling}
        error={state.error}
        onChangeCategory={setCategory}
        onDownloadPdf={downloadPdfFunc}
      />
    </div>
  );
};
